<template>
    <span :class="{ 'has-error': $v.value.$error }">
        <span class="form__label" :class="{ 'error_input': $v.value.$error }">
            <label :for="name" class="form__label-title">{{ label }}<span v-if="required">*</span></label>
            <div class="input-container">
                <div class="country-code-select">
                    <select :class="[{ 'error_input': $v.value.$error }, 'country-select']" v-model="selectedCountry" @change="updateMask">
                        <option v-for="country in options"
                                :key="country.text"
                                :value="country.value" :title="country.text">
                            {{ country.text }}
                        </option>
                    </select>
                </div>
                <input class="form__input"
                       :id="name"
                       :name="name"
                       :type="type"
                       :placeholder="placeholder + selectedCountry"
                       :required="required"
                       :validators="validators"
                       v-model.trim="$v.value.$model"
                       @change="containsError($v.value)"
                       @keyup="containsError($v.value)"
                       v-bind="$attrs"/>
            </div>
            <label v-if="required && $v.value.$dirty && !$v.value.required" class="form__label-title error">{{ $t('validations.required') }}</label>
            <label v-if="minLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'minLength').localizedErrorMessage) }}</label>
            <label v-if="maxLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'maxLength').localizedErrorMessage) }}</label>
            <label v-if="regexValidation" class="form__label-title error">
                {{ translate(findValidator(this.validators, 'regExp', selectedCountry).localizedErrorMessage) }}
            </label>
        </span>
    </span>
</template>

<script>
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

export default {
  name: 'OnboardPhoneNumberInput',
  mixins: [OnboardInputMixin],
  mounted() {
    this.value = this.$attrs.options[0].value;
  },
  data() {
    return {
      options: this.$attrs.options,
      selectedCountry: this.$attrs.options[0].value,
    };
  },
  methods: {
    updateMask(value) {
      this.selectedCountry = value.target.value;
      this.value = value.target.value;
    },
  },
};

</script>

<style scoped>
    .input-container {
        display: flex;
        align-items: center;
    }

    .country-code-select {
        display: inline-block;
        width: 50%;
    }

    #MobilePhoneNumber {
        display: inline-block;
        width: 80%;
    }

    .form__label {
        display: block;
    }

    label[for=MobilePhoneNumber] {
        margin-bottom: -5px;
    }

    .country-code-select select {
        border-bottom: 1px solid #bebebe;
        border-right: 1px solid #bebebe;
        border-left: 1px solid #bebebe;
        border-radius: 0px 0 4px 4px;
        border-top: none;
        border-right: none;
        padding-left: 5px;
    }
</style>
